
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Home, GraduationCap, Settings, FileText } from "lucide-react";
import { memo, useCallback } from "react";
import { devLog } from "@/utils/devLog";

// Updated navigation items - removed My Learning as a separate destination
const navItems = [
  {
    name: "Dashboard",
    href: "/dashboard/student",
    icon: <Home size={20} />,
    description: "Overview of your enrolled courses and progress"
  },
  {
    name: "My Notes",
    href: "/dashboard/student/notes",
    icon: <FileText size={20} />,
    description: "Access your course notes"
  },
  {
    name: "Settings",
    href: "/dashboard/student/settings",
    icon: <Settings size={20} />,
    description: "Manage your account preferences"
  }
];

// Using memo to prevent unnecessary re-renders
export const SidebarNavItems = memo(function SidebarNavItems() {
  const location = useLocation();
  
  devLog("[SidebarNavItems] Rendering with path:", location.pathname);
  
  const handleItemClick = useCallback((name: string) => {
    devLog(`[SidebarNavItems] Nav item clicked: ${name}`);
  }, []);
  
  return (
    <nav className="space-y-1">
      {navItems.map((item) => {
        const isActive = location.pathname === item.href || 
                        (item.href !== '/dashboard/student' && location.pathname.startsWith(item.href));
        
        devLog(`[SidebarNavItems] Item ${item.name} isActive:`, isActive);
        
        return (
          <Link 
            key={item.name} 
            to={item.href}
            onClick={() => handleItemClick(item.name)}
          >
            <Button
              variant="ghost"
              className={cn(
                "w-full justify-start gap-3 font-normal",
                isActive && "bg-primary/10 text-primary font-medium"
              )}
            >
              {item.icon}
              {item.name}
            </Button>
          </Link>
        );
      })}
    </nav>
  );
});
